<div class="flex pt-2" appManageValidatorDisplay [control]="formControl">
  <cap-calendar
    [formControl]="formControl"
    [label]="props.label"
    [minDate]="props.min_date"
    [maxDate]="props.max_date"
    [showIcon]="false"
    [placeholder]="props.placeholder"
    [hasTooltip]="props.tooltip"
    styleClass="p-inputgroup">
    <app-form-tooltip [text]="props.tooltip" class="tooltip-content"></app-form-tooltip>
  </cap-calendar>
</div>
